import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import HomePage from './pages/home/home';
import HireUsPage from './pages/hireus/hireuspage';

import './App.css';


const App = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <meta name="description" content="Buy, sell, or invest in real estate in Spokane, WA with Patrick Kendrick, your trusted real estate agent." />
        <meta name="author" content="Patrick Kendrick Real Estate" />
        <meta name="keywords" content="Real Estate, Realtor, Homes for Sale, Buy House, Sell House, Spokane, Washington, Investment Properties" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="en-US" />
        <meta name="geo.region" content="US-WA" />
        <meta name="geo.placename" content="Spokane" />
        <meta name="geo.position" content="47.6588;-117.4260" />
        <meta name="ICBM" content="47.6588, -117.4260" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hire-us" element={<HireUsPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};
export default App;